export const BASE = ['orgSettings'] as const;

export const ORG_SETTINGS_QUERY_KEYS = {
  getSettings: () => [...BASE, 'settings'] as const,
};
